import { FC } from "react";

const MAX_COUNT = 9999;

export const TicketsSidebarCount: FC<{
  count: number;
}> = ({ count }) => {
  const label = count > MAX_COUNT ? `${MAX_COUNT}+` : String(count);

  return (
    <div className="flex h-[18px] shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-solid border-[#EEF2F5] bg-white px-1 text-[10px] font-medium text-[#5A6367]">
      {label}
    </div>
  );
};
